import React, { useState } from 'react';
import './Skills.css'; // Import your CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faCodeBranch, faBitcoinSign, faCloud, faServer, faLayerGroup , faLaptopCode, faDatabase, faShieldAlt, faKey, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const Skills = () => {
  const [expandedCategories, setExpandedCategories] = useState([]);

  const skillData = [
    {
      category: "Full Stack Development",
      icon: faCode,
      experience: "More than 2 years",
      skills: [
        { name: "HTML", level: 90 },
        { name: "CSS", level: 80 },
        { name: "JavaScript", level: 90 },
        { name: "PHP", level: 80 },
        { name: "jQuery", level: 70 },
        { name: "REST API", level: 80 },
        { name: "JSON", level: 85 },
        { name: "TypeScript", level: 75 },
        { name: "Tailwind CSS", level: 70 },
      ],
    },
    {
      category: "MERN Stack",
      icon: faLayerGroup,
      experience: "More than 2 years",
      skills: [
        { name: "React.js", level: 85 },
        { name: "Node.js", level: 85 },
        { name: "Express.js", level: 80 },
        { name: "MongoDB", level: 85 },
      ],
    },
    {
      category: "Programming",
      icon: faLaptopCode,
      experience: "More than 4 years",
      skills: [
        { name: "C++", level: 90 },
        { name: "Object-oriented Programming", level: 80 },
        { name: "Data Structures and Algorithms", level: 90 },
      ],
    },
    {
      category: "Databases",
      icon: faDatabase,
      experience: "More than 2 years",
      skills: [
        { name: "SQL", level: 80 },
        { name: "MongoDB", level: 85 },
        { name: "NoSQL", level: 75 },
      ],
    },
    {
      category: "Version Control and Project Management Tools",
      icon: faCodeBranch,
      experience: "More than 2 years",
      skills: [
        { name: "VS Code", level: 85 },
        { name: "Git", level: 85 },
        { name: "GitHub", level: 80 },
        { name: "Bitbucket", level: 75 },
        { name: "Zira", level: 70 },
      ],
    },
    {
      category: "Cloud Development Services",
      icon: faCloud,
      experience: "More than 1 year",
      skills: [
        { name: "AWS", level: 70 },
      ],
    },
    {
      category: "CMS",
      icon: faServer,
      experience: "More than 1 year",
      skills: [
        { name: "WordPress", level: 75 },
        { name: "Sanity.io", level: 70 },
      ],
    },
    {
      category: "Cybersecurity",
      icon: faShieldAlt,
      experience: "More than 1 year",
      skills: [
        { name: "Cryptography", level: 75 },
        { name: "LSB Steganography", level: 70 },
      ],
    },
    {
      category: "Authentication Protocols",
      icon: faKey,
      experience: "More than 1 year",
      skills: [
        { name: "SAML", level: 70 },
        { name: "OAuth", level: 75 },
        { name: "SCIM", level: 70 },
      ],
    },
    {
      category: "Cryptocurrency",
      icon: faBitcoinSign,
      experience: "More than 1 year",
      skills: [
        { name: "Blockchain", level: 75 },
        { name: "Smart Contracts", level: 70 },
        { name: "Ganache", level: 65 },
        { name: "Metamask", level: 70 },
        { name: "Truffle", level: 65 },
        { name: "Solidity", level: 70 },
      ],
    },
  ];

  const toggleCategory = (index) => {
    if (expandedCategories.includes(index)) {
      setExpandedCategories(expandedCategories.filter(item => item !== index));
    } else {
      setExpandedCategories([...expandedCategories, index]);
    }
  };

  return (
    <div className="skills-container" id="skills">
      <h2 className="skills-title">Skills</h2>
      <p className="skills-subtitle">My technical level</p>
      <div className="skills-content">
        {skillData.map((category, index) => (
          <div className="skills-category" key={index}>
            <h3 className="skills-category-title" onClick={() => toggleCategory(index)}>
              <FontAwesomeIcon icon={category.icon} className="skills-category-icon" /> {category.category}
              <FontAwesomeIcon 
                icon={expandedCategories.includes(index) ? faChevronUp : faChevronDown} 
                className={`dropdown-arrow ${expandedCategories.includes(index) ? 'expanded' : ''}`} 
              />
            </h3>
            {category.experience && (
              <p className="skills-category-subtitle">{category.experience}</p>
            )}
            <ul className={`skills-list ${expandedCategories.includes(index) ? 'expanded' : ''}`}>
              {category.skills.map((skill, idx) => (
                <li key={idx}>
                  <div className="progress-bar-container">
                    <div className="skill-name">{skill.name}</div>
                    <div className="progress-bar">
                      <div
                        className="progress-bar-filled"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                      <div className="skill-percentage">{skill.level}%</div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
